module.exports = __webpack_public_path__ + "img/img56.1fe8514b.svg";